// src/oura/newscan/outletIntent.ts
//
// "Name the area" on a First AI check card opens the Business step with the
// outlet field already open: the form's area typed in, its town worked out,
// and the row marked as the client's. The Review sets the intent, the
// Business step's outlet list takes it once.

import type { ItemSource } from "@service/aeo/scanDraftTypes";

export interface OutletIntent {
    /** What the field opens with: the area as the form wrote it. */
    name: string;
    /** The town its city-wide questions ask, when Oura knows it ("PJ" for Petaling Jaya). */
    town: string | null;
    /** Where the place came from: the client's form. */
    source: ItemSource;
}

let pending: OutletIntent | null = null;

export function setOutletIntent(intent: OutletIntent | null): void {
    pending = intent;
}

/** The intent, once: a later visit to the Business step opens as usual. */
export function takeOutletIntent(): OutletIntent | null {
    const out = pending;
    pending = null;
    return out;
}
